<template>
  <div class="top-menu" style="min-width: 1300px" :class="{ 'extra-index': getVisibleEnroll }">
    <div class="header-nav flex-wrap clearfix">
      <div class="logo col-flex-1">
        <a href="/search" title="一起学">
          <img title="一起科技" class="logo_img fixed" src="./../assets/17logo.png" alt="一起科技"
        /></a>
      </div>
      <div v-if="showSubject" class="col-flex-1">
        <div v-if="noPick" class="tkn-dropdown-toggle" style="padding-right: 5px;">
          <span class="current-subject">{{ currentSubject }}</span>
        </div>
        <div
          v-else
          class="tkn-dropdown-toggle"
          @mouseenter="down = false"
          @mouseleave="down = true"
        >
          <!-- <div class="tkn-dropdown-toggle" @click="down = !down"> -->
          <span class="current-subject">{{ currentSubject }}</span>
          <a-icon v-show="down" type="caret-down" />
          <a-icon v-show="!down" type="caret-up" />
          <!-- v-if="!down" -->
          <div class="subject-dropdown">
            <div v-for="(item, index) in subjects" :key="index">
              <div class="left-item">{{ item.label }}</div>
              <div class="right-item">
                <span
                  v-for="(sub, subIndex) in item.subs"
                  :class="[currentSubject === sub.label ? 'active-subject' : '']"
                  :key="subIndex"
                  @click="selectTab(sub)"
                >
                  {{ sub.label }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="tkn-tabs" style="align-self: flex-end;">
          <span
            style="margin: 0 5px"
            :class="['tkn-tab', activeTab === 2 ? 'actived-tab' : '']"
            @click="selectItem(2)"
            >手工组卷</span
          >
          <span
            style="margin: 0 5px"
            :class="['tkn-tab', activeTab === 5 ? 'actived-tab' : '']"
            @click="selectItem(5)"
            >智能出题</span
          >
          <span
            style="margin: 0 5px"
            :class="['tkn-tab', activeTab === 1 ? 'actived-tab' : '']"
            @click="selectItem(1)"
            >试卷</span
          >
          <span
            style="margin: 0 5px"
            :class="['tkn-tab1', activeTab === 4 ? 'actived-tab' : '']"
            @click="selectItem(4)"
            >素材·课件·讲义</span
          >
          <!-- 初数和初英展示 -->
          <span
            style="margin: 0 5px"
            v-if="[202, 203].includes(subjectObj.value)"
            :class="['tkn-tab', activeTab === 6 ? 'actived-tab' : '']"
            @click="selectItem(6)"
            >试卷分析</span
          >
        </div>
      </div>
      <template v-if="!currentUser">
        <div class="col-flex-1 log-btns ">
          <vip-entry></vip-entry>
          <img
            style="margin-left: 20px; margin-right: 5px;"
            src="./../assets/svg/feedback.svg"
            @click="showFeedBack"
            alt=""
          />
          <FeedBack @close="closeShowFeed" :value="feedbackModal"></FeedBack>
          <a-button size="small" type="primary" class="tkn-btn_default login-btn" @click="sign">
            登录
          </a-button>
          <a-button size="small" @click="enroll">注册</a-button>
          <CmineLogin
            :current="currentTab"
            v-model="visibleEnroll"
            @go_login="loginHandler"
            @login_success="giveVipPresentHandler"
            @go_enroll="enrollHandler"
            @on_cancel="closeEnrollModal"
          ></CmineLogin>
        </div>
      </template>
      <template v-if="currentUser">
        <div class="col-flex-1 log-btns">
          <Invent @show-info="showInfo" @share-to-wx="clickWx"></Invent>
          <vip-entry></vip-entry>
          <a href="javascript: 0;" @click="toMyDownload" class="top-label"
            ><img class="download" src="@/assets/images/download.png" alt="" />我的下载</a
          >
          <img
            style="margin-right: 5px;"
            src="./../assets/svg/feedback.svg"
            @click="showFeedBack"
            alt=""
          />
          <FeedBack @close="closeShowFeed" :value="feedbackModal"></FeedBack>
          <div class="tkn-dropdown-toggle">
            <span class="current-subject personal-item">
              <img v-if="!curUserInfo.is_member" src="@/assets/images/avatar.png" alt="" />
              <img v-if="curUserInfo.is_member" src="@/assets/images/avatar-vip.png" alt="" />
              <span
                :class="[curUserInfo.is_member ? 'vip-mark' : '']"
                v-if="typeof curUserInfo != 'undefined' && curUserInfo.username"
                style="display: inline-block;vertical-align: bottom;max-width: 102px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;"
                >{{ curUserInfo.username }}</span
              >
            </span>
            <a-icon class="caret" v-show="perDropShow" type="caret-down" />
            <!-- <a-icon v-show="!perDropShow" type="caret-up" /> -->
            <div class="person-dropdown">
              <div class="info1">
                <span
                  :class="[curUserInfo.is_member ? 'vip-mark' : '']"
                  v-if="typeof curUserInfo != 'undefined' && curUserInfo.username"
                  >{{ curUserInfo.username }}</span
                >
                <span
                  :class="[curUserInfo.is_member ? 'vip-mark' : '']"
                  v-if="typeof curUserInfo != 'undefined' && !curUserInfo.username"
                  >{{ currentUser }}</span
                >
                <span @click="logoutHandler" style="color:rgba(21, 118, 243, 1)">退出</span>
              </div>
              <div>
                <span
                  @click="modifyInfo"
                  v-if="showCompletion"
                  target="_blank"
                  href="/search/personal/mine"
                  class="prove-info"
                  >补充资料得免费下载次数</span
                >
                <span v-if="!showCompletion" class="prove-info">
                  <img src="@/assets/images/school.png" alt="" />
                  {{ curUserInfo.city + '  ' + curUserInfo.school }}
                  <img src="@/assets/images/subject.png" alt="" />
                  {{ curUserInfo.subject }}
                  <!-- <a-icon type="home" /><span style="margin-right:20px;">{{
                    curUserInfo.city + '  ' + curUserInfo.school
                  }}</span>
                  <a-icon type="book" />{{ curUserInfo.subject }} -->
                </span>
              </div>
              <div class="info2">
                <a href="/search/personal/secure" class="item">
                  <div>
                    <img src="./../assets/images/1p.png" alt="" />
                  </div>
                  <a>账号安全</a>
                </a>
                <!-- <a class="item" href="/search/personal/party">
                  <div>
                    <img src="./../assets/images/3p.png" alt="" />
                  </div>
                  <a>绑定第三方账号</a>
                </a> -->

                <div class="item">
                  <div @click="showFeedBack">
                    <img src="./../assets/images/2p.png" alt="" />
                  </div>
                  <div style="text-align: center; margin-left:30px;">
                    <FeedBack @close="closeShowFeed" :value="feedbackModal"></FeedBack>
                  </div>
                </div>
              </div>
              <a href="/search/personal/mine" class="info3">
                <span>进入个人中心</span>
              </a>
            </div>
          </div>
        </div>
      </template>
    </div>
    <!-- 赠送会员包组件 -->
    <vip-present :value="isShowPre"></vip-present>
    <invent-info
      v-model="showInventInfo"
      @on-cancel="inventInfoCancel"
      :url="inventUrl"
      @share-to-wx="clickWx"
    ></invent-info>
    <invent-banner
      v-model="showInventBanner"
      @on-cancel="inventBannerCancel"
      @share-to-wx="clickWx"
    ></invent-banner>
    <Qrcode v-model="showInventQrcode" @on-cancel="inventQrcodeCancel" :link="inventUrl"></Qrcode>
    <tip-modal></tip-modal>
  </div>
</template>

<script>
import { Select } from 'ant-design-vue'
import { msgTip } from '@/utils/urlUtils'
import { api_get } from '@/utils/http.ts'
import { loadFromLocal, saveToLocal } from '@/utils/local'
const Option = Select.Option
import CmineLogin from '@/components/enroll/CmineLogin.vue'
import { mapMutations } from 'vuex'
import { getInitInfo, getCurrentUserInfo } from '../apps/index/models/api'
import FeedBack from '@/components/FeedBack.vue'
import VipPresent from '@/components/vip/VipPresent'
import VipEntry from '@/components/vip/VipEntry'
import Invent from '@/components/invent/Invent.vue'
import InventInfo from '@/components/invent/InventInfo.vue'
import InventBanner from '@/components/invent/InventBanner.vue'
import Qrcode from '@/components/invent/Qrcode.vue'
import TipModal from '@/components/common/TipModal.vue'
import { getIsCmsAdmin } from '../apps/handout/models/api'

export default {
  name: 'topMenu',
  props: {
    msg: String,
    noPick: Boolean,
    showSubject: {
      default() {
        return true
      },
      type: Boolean
    }
  },
  watch: {
    payModal: {
      handler(val) {
        if (val && !val.state) {
          this.getUserDetail()
        }
      }
    },
    getVisibleEnroll: {
      handler(val) {
        if (typeof val === 'boolean') {
          this.visibleEnroll = val
          this.currentTab = 1
        } else {
          this.visibleEnroll = val[0]
          this.currentTab = 2
        }
      }
    }
    // 判断登陆后是否在白名单里
    // currentUser: {
    //   handler(val) {
    //     if (val) {
    //       this.getWhiteCmsAdmin()
    //     }
    //   }
    // }
  },
  mounted() {
    this.setSubject(this.subject)
    this.currentSubject = this.subject.label
    this.getBaseInfo(this.subject.value)
    this.$emit('subject', this.currentSubject)
    //点亮会员图标
    this.getUserDetail()
    if (this.token) {
      this.$store.commit('SET_LOGINMODAL', [true, 2])
    } else {
      this.$store.commit('SET_LOGINMODAL', false) // 状态重置
    }
    // 判断白名单
    this.getWhiteCmsAdmin()
  },
  data() {
    return {
      //出发反馈的弹窗
      feedbackModal: false,
      //是否提示赠送优惠券的弹窗提示
      isShowPre: false,
      currentSubject: '',
      baseInfo: [],
      subjects: [],
      perDropShow: true,
      down: true,
      currentTab: 2,
      tel: '',
      title: '注册',
      visibleTest: false,
      visibleEnroll: false,
      visibleLogin: false,
      subjectDrop: true,
      showInventInfo: false,
      showInventBanner: false,
      inventUrl: '',
      showInventQrcode: false
    }
  },
  components: {
    CmineLogin,
    FeedBack,
    VipEntry,
    VipPresent,
    Invent,
    InventInfo,
    Qrcode,
    InventBanner,
    TipModal
  },
  methods: {
    async getUserDetail() {
      let d = await getCurrentUserInfo()
      if (d.success) {
        this.$store.commit('SET_USER_INFO', d.data)
      }
    },
    modifyInfo() {
      window.open('/search/personal/mine')
    },
    closeShowFeed() {
      this.feedbackModal = false
    },
    showFeedBack() {
      this.feedbackModal = true
    },
    giveVipPresentHandler(flag) {
      let that = this
      setTimeout(function() {
        if (flag) {
          that.isShowPre = true
        }
      }, 1000)
      // window.location.href = window.location.href || '/search/index'
      // 登录成功显示 banner
      // console.log(this.curUserInfo)
      // if (this.curUserInfo && this.curUserInfo.is_oto_account) {
      //   this.showInventBanner = false
      // } else {
      //   this.showInventBanner = true
      // }
    },
    ...mapMutations({
      setSubject: 'SET_SUBJECT'
    }),
    saveSubject(val) {
      saveToLocal('subject', val)
    },
    async getBaseInfo(val) {
      let temp = {}
      let subjects = []
      let xx = {
        label: '小学',
        subs: []
      }
      let cz = {
        label: '初中',
        subs: []
      }
      let gz = {
        label: '高中',
        subs: []
      }
      let qt = {
        label: '其他',
        subs: []
      }
      let xq = {
        label: '学前',
        subs: []
      }
      let zbcz = {
        label: '直播',
        subs: []
      }
      let grades = {
        name: '年级：',
        label: 'grade',
        val: []
      }
      let xuekeGrades = {
        name: '年级：',
        label: 'grade',
        val: []
      }
      let sections = {
        name: '地区：',
        label: 'section',
        val: [{ name: '全部', val: 0 }]
      }
      let years = {
        name: '年份：',
        label: 'year',
        val: []
      }
      let terms = {
        name: '学期：',
        label: 'term',
        val: []
      }
      let origins = {
        name: '来源：',
        label: 'sort_way',
        val: []
      }
      let siteChoices = []
      let { data } = await getInitInfo({
        subject_id: val
      })
      for (let n of data.subject_choices) {
        if (/^1\d{2}$/.test(n[0])) {
          xx.subs.push({
            label: n[1],
            value: n[0]
          })
        } else if (/^2\d{2}$/.test(n[0])) {
          cz.subs.push({
            label: n[1],
            value: n[0]
          })
        } else if (/^3\d{2}$/.test(n[0])) {
          gz.subs.push({
            label: n[1],
            value: n[0]
          })
        } else if (/^4\d{2}$/.test(n[0])) {
          qt.subs.push({
            label: n[1],
            value: n[0]
          })
        } else if (/^5\d{2}$/.test(n[0])) {
          xq.subs.push({
            label: n[1],
            value: n[0]
          })
        } else if (/^7\d{2}$/.test(n[0])) {
          zbcz.subs.push({
            label: n[1],
            value: n[0]
          })
        }
      }
      subjects = [xx, cz, gz]
      this.subjects = subjects
      for (let n of data.grade_choices) {
        grades.val.push({
          name: n[1],
          val: n[0]
        })
      }
      for (let n of data.xueke_choices) {
        xuekeGrades.val.push({
          name: n[2],
          val: n[0],
          rating: n[1]
        })
      }
      for (let n of data.region_choices) {
        sections.val.push({
          name: n[1],
          val: n[0]
        })
      }
      for (let n of data.year_choices) {
        years.val.push({
          name: n[1],
          val: n[0]
        })
      }
      for (let n of data.term_choices) {
        terms.val.push({
          name: n[1],
          val: n[0]
        })
      }
      for (let n of data.paper_type_choices) {
        origins.val.push({
          name: n[1],
          val: n[0]
        })
      }
      siteChoices = data.site_choices
      // this.$store.commit('SET_GRADES', grades)
      // this.$store.commit('SET_SECTIONS', sections)
      // this.$store.commit('SET_YEARS', years)
      // this.$store.commit('SET_ORIGINS', origins)
      this.$store.commit('SET_SITECHOICES', siteChoices)
      this.$store.commit('SET_XUEKECHOICE', [xuekeGrades, sections, years, origins])
      this.$store.commit('SET_ALLRULES', [grades, sections, years, terms, origins])
      this.$store.commit('SET_GRADES', [grades, sections, years, origins])
    },
    async logoutHandler() {
      let rdata = await api_get('/search/api/auth/logout', {})
      if (rdata.success) {
        msgTip({
          type: 'success',
          msg: rdata.msg
        })
        //logout logic
        saveToLocal('net_username', '')
        this.$store.commit('SET_USER', { name: null })
        this.$store.commit('SET_USER_INFO', undefined)
        window.location.href = '/search'
      } else {
        msgTip({
          type: 'error',
          msg: rdata.error || 'error'
        })
      }
    },
    selectTab(item) {
      this.currentSubject = item.label
      this.setSubject(item)
      this.saveSubject(item)
      this.getBaseInfo(item.value)
      // this.$emit('subject', item)
      this.subjectDrop = true
      // 选择学科时上报
      setTimeout(() => {
        this.$sa.track('ContentRepository_Top', {
          subject: item.label
        })
      }, 50)
    },
    handleChange(value) {
      console.log(`selected ${value}`)
    },
    selectItem(k) {
      // this.activeTab = k
      if (k == 1) {
        this.$sa.track('ContentRepository_Top', {
          lvevl1Menu: '试卷',
          subject: this.currentSubject
        })
        location.href = '/search/paper'
      } else if (k === 2) {
        this.$sa.track('ContentRepository_Top', {
          lvevl1Menu: '题目',
          subject: this.currentSubject
        })
        location.href = '/search'
      } else if (k === 3) {
        this.$sa.track('ContentRepository_Top', {
          lvevl1Menu: '拍搜',
          subject: this.currentSubject
        })
        location.href = '/search/question/photosearch'
      } else if (k === 4) {
        this.$sa.track('ContentRepository_Top', {
          lvevl1Menu: '素材·课件·讲义',
          subject: this.currentSubject
        })
        location.href = '/search/handout'
      } else if (k === 5) {
        this.$sa.track('ContentRepository_Top', {
          lvevl1Menu: '智能出题',
          subject: this.currentSubject
        })
        location.href = '/search/auto'
      } else if (k === 6) {
        // 埋点
        // this.$sa.track('ContentRepository_Top', {
        //   lvevl1Menu: '智能出题',
        //   subject: this.currentSubject
        // })
        location.href = '/search/analysis'
      }
    },
    callback(key) {
      console.log(key)
    },
    loginHandler() {
      this.currentTab = 1
    },
    enrollHandler() {
      this.currentTab = 2
    },
    third() {
      this.visibleThird = true
    },

    closeVisModal() {
      this.visibleTest = false
    },
    closeEnrollModal() {
      this.visibleEnroll = false
      this.$store.commit('SET_LOGINMODAL', false)
    },
    closeLoginModal() {
      this.visibleLogin = false
    },
    sign() {
      // this.visibleLogin = true
      this.visibleEnroll = true
      this.currentTab = 1
    },
    enroll() {
      this.visibleEnroll = true
      this.currentTab = 2
    },
    showInfo(val) {
      this.inventUrl = val
      this.showInventInfo = true
      setTimeout(() => {
        this.$sa.track('ContentRepository_Share', {
          action: '打开分享详情'
        })
      }, 50)
    },
    inventInfoCancel() {
      this.showInventInfo = false
    },
    inventQrcodeCancel() {
      this.showInventQrcode = false
    },
    clickWx(val) {
      this.inventUrl = val
      setTimeout(() => {
        this.$sa.track('ContentRepository_Share', {
          action: '开始分享',
          shareChannel: '微信分享'
        })
      }, 50)
      this.showInventQrcode = true
    },
    inventBannerCancel() {
      this.showInventQrcode = false
    },
    toMyDownload() {
      this.$sa.track('ContentRepository_Top', {
        lvevl1Menu: '我的下载'
      })
      location.href = '/search/personal/download'
    },
    // 设置白名单
    async getWhiteCmsAdmin() {
      // let d = await getIsCmsAdmin()
      // if (d.success) {
      //   if (d.msg) {
      //     this.$store.commit('SET_HANDOUTSHOW', true)
      //   } else {
      //     this.$store.commit('SET_HANDOUTSHOW', false)
      //   }
      // }
    }
  },
  computed: {
    payModal() {
      return this.$store.state.payModal
    },
    showCompletion() {
      if (
        this.curUserInfo &&
        this.curUserInfo.city &&
        this.curUserInfo.learn_stage &&
        this.curUserInfo.provence &&
        this.curUserInfo.school &&
        this.curUserInfo.subject
      ) {
        return false
      }
      return true
    },
    activeTab() {
      let key = this.$route.name
      switch (key) {
        case 'question':
          return 2
        case 'questionPreview':
          return 2
        case 'questionFinish':
          return 2
        case 'index':
          return 2
        case 'paper':
          return 1
        case 'finish':
          return 1
        case 'pdf':
          return 1
        case 'detail':
          return 1
        case 'paperpreview':
          return 1
        case 'photosearch':
          return 3
        case 'handout':
          return 4
        case 'auto':
          return 5
        case 'autopreview':
          return 5
        case 'analysis':
          return 6
        case 'analysisChart':
          return 6
        case 'questionDetail':
          return 6
        default:
          return 2
      }
    },
    getVisibleEnroll() {
      if (this.$store) {
        return this.$store.state.loginModal
      } else {
        return false
      }
    },
    // showSubject: function() {
    //   return !/(personal)/g.test(window.location.href)
    // },
    currentUser() {
      return this.$store.state.user ? this.$store.state.user.name : undefined
    },
    curUserInfo() {
      return this.$store.state.user_info
        ? this.$store.state.user_info
        : {
            city: '',
            learn_stage: '',
            provence: '',
            school: '',
            subject: ''
          }
    },
    subject() {
      let obj1 = {
        label: this.$route.query.subject_name,
        value: this.$route.query.subject_id
      }
      let obj2 = loadFromLocal('subject')
      let obj3 = {
        label: '小学语文',
        value: 101
      }
      if (obj1 && obj1.value && obj1.label) {
        return obj1
      } else if (obj2 && obj2.value && obj2.label) {
        return obj2
      } else {
        return obj3
      }
    },
    subjectId() {
      return this.$route.query.subject_id || '101'
    },
    token() {
      return this.$route.query.token || ''
    },
    // 学科信息
    subjectObj: {
      get() {
        return this.$store.state.subject
      },
      set(val) {
        this.subjectObj = val
      }
    }
  }
}
</script>
<style scoped lang="scss">
.download {
  width: 15px;
  height: 17px;
}
.top-label {
  img {
    margin-right: 7px;
    vertical-align: sub;
  }
  margin: 0px 20px;
  cursor: pointer;
  font-size: 14px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.65);
}
.dropdown {
  display: none;
}
.extra-index {
  z-index: 1001 !important;
}
.top-menu {
  flex-shrink: 0;
  .subject-dropdown {
    width: 550px;
    height: 0px;
    overflow: hidden;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.16);
    border-radius: 2px;
    position: absolute;
    transition: height 0.3s ease;
    top: 150%;
    left: 0;
    z-index: 1020;
    float: right;
    text-align: left;
    border-radius: 2px;
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.16);
    -webkit-box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.16);
    .left-item {
      vertical-align: top;
      width: 10%;
      display: inline-block;
      height: 22px;
      font-size: 14px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      color: gray;
      line-height: 22px;
    }
    .right-item {
      width: 90%;
      display: inline-block;
      height: 22px;
      span {
        padding: 0px 32px 20px 0px;
        display: inline-block;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.65);
      }
      .active-subject {
        font-weight: 500;
        color: rgba(0, 122, 255, 1);
      }
    }
  }
  .log-btns {
    text-align: right;
    font-size: 14px;
    font-family: PingFangSC-Regular;
    font-weight: 400;

    // line-height: 22px;
    button {
      color: rgba(255, 255, 255, 1);
      border-radius: 4px;
      height: 35px;
      width: 65px;
    }
  }
  .log-btns button:nth-last-of-type(2) {
    margin: 0px 30px;
  }
  .log-btns button:last-of-type {
    opacity: 0.4;
    background: linear-gradient(90deg, rgba(0, 122, 255, 1) 0%, rgba(81, 153, 255, 1) 100%);
  }
  .subject-dropdown > div {
    padding: 20px 20px 0px;
  }
  .tkn-dropdown-toggle:hover .subject-dropdown {
    height: 250px;
  }
  .tkn-tabs .actived-tab:before {
    width: 100%;
  }
  .person-dropdown {
    width: 360px;
    // height: 260px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 4px 0px rgba(157, 159, 161, 1);

    position: absolute;
    top: 100%;
    right: 0;
    height: 0px;
    // z-index: 1000;
    overflow: hidden;
    transition: height 0.3s ease;
    float: left;
    min-width: 160px;
    padding: 0px 0px;
    margin: 2px 0 0;
    list-style: none;
    font-size: 14px;
    text-align: left;
    border-radius: 2px;
    & > div {
      padding: 10px 20px;
    }
    .info1 {
      padding: 20px 20px 0px 20px;
      .vip-mark {
        color: rgba(88, 89, 94, 1);
        line-height: 22px;
        background: linear-gradient(270deg, rgba(255, 209, 112, 1) 0%, rgba(255, 184, 27, 1) 100%);
        background-clip: text;
        -webkit-text-fill-color: transparent;
      }
      .prove-info {
        width: 138px;
        height: 16px;
        font-size: 12px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(89, 89, 89, 1);
        line-height: 16px;
      }
      span:nth-child(1) {
        width: 122px;
        height: 28px;
        font-size: 20px;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        line-height: 28px;
      }
      span:nth-child(2) {
        float: right;
        width: 28px;
        height: 22px;
        font-size: 14px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(21, 118, 243, 1);
        line-height: 22px;
      }
    }
    .prove-info {
      i {
        padding-right: 5px;
        color: rgba(151, 151, 151, 1);
      }
    }

    .info2 {
      padding: 20px;
      border-top: 1px solid rgba(0, 0, 0, 0.09);
      border-bottom: 1px solid rgba(0, 0, 0, 0.09);
      display: flex;
      .item {
        & > div {
          margin-bottom: 5px;
        }
        a {
          color: rgba(0, 0, 0, 0.65);
        }
        flex: 1;
        text-align: center;
      }
    }
    .info3 {
      width: 100%;
      display: inline-block;
      height: 50px;
      line-height: 50px;
      text-align: center;
      span {
        font-size: 14px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(89, 89, 89, 1);
      }
    }
  }
  .tkn-dropdown-toggle:hover .person-dropdown {
    height: 260px;
  }
  .tkn-dropdown-toggle:hover .caret {
    transform: rotate(180deg);
  }
  .tkn-dropdown-toggle {
    margin: 20px 0px;
    .vip-mark {
      color: rgba(88, 89, 94, 1);
      line-height: 22px;
      background: linear-gradient(270deg, rgba(255, 209, 112, 1) 0%, rgba(255, 184, 27, 1) 100%);
      background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }

  .current-subject {
    span {
      padding: 0px 7px;
    }
    img {
      width: 15px;
      height: 17px;
      vertical-align: sub;
    }
    width: 56px;
    height: 22px;
    font-size: 14px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    color: rgba(0, 0, 0, 1);
    line-height: 22px;
  }
  .personal-item {
    color: rgba(0, 0, 0, 0.65);
    width: 56px;
    height: 22px;
    font-size: 14px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    line-height: 22px;
  }
  height: 64px;
  z-index: 999;
  background: #fff;
  width: 100%;
  .header-nav {
    height: 64px;
    margin: 0px 128px 0px 128px;
    position: relative;
    z-index: 2;
    .header-cont {
      height: 64px;
      width: 83%;
    }
    .logo {
      max-width: 100px;
      line-height: 64px;
      .logo_img {
        width: 90px;
        height: 30px;
        line-height: 80px;
      }
    }
  }
}

@media screen and (max-width: 1366px) {
  .top-menu {
    height: 48px;
    .header-nav {
      height: 48px;
      margin: 0px 80px;
      position: relative;
      z-index: 2;
      .header-cont {
        height: 48px;
        width: 83%;
      }
      .logo {
        max-width: 100px;
        line-height: 48px;
        .logo_img {
          width: 90px;
          height: 30px;
          line-height: 80px;
        }
      }
    }
    .log-btns {
      button {
        height: 25px;
        width: 55px;
      }
    }
  }
}
</style>
